import { config as variantConfig } from '@/pageConfig/home/us/a-swap-reviews-products';
import { HomePageTemplate } from '@/pageTemplate/HomePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomeSwapReviewsProductsVariant() {
  const { trackEvent, trackDataForGtm } = useAnalyticsContext();
  useEffect(() => {
    trackEvent('home_page.viewed', {
      experiment: 'swap_reviews_products_on_a',
    });
    trackDataForGtm('homepage_viewed');
  }, []);

  return <HomePageTemplate config={variantConfig} />;
}
